import { DollarSign, Gift, LayoutGrid, List } from 'lucide-react';
import { motion } from 'motion/react';
import { cn } from '../lib/utils';

interface BottomNavProps {
  activeTab:
    | 'overview'
    | 'expenditure'
    | 'income'
    | 'debt'
    | 'support'
    | 'assets'
    | 'budget'
    | 'subscriptions'
    | 'savings'
    | 'asset-detail';
  setActiveTab: (
    tab:
      | 'overview'
      | 'expenditure'
      | 'income'
      | 'debt'
      | 'support'
      | 'assets'
      | 'budget'
      | 'subscriptions'
      | 'savings'
      | 'asset-detail'
  ) => void;
}

export function BottomNav({ activeTab, setActiveTab }: BottomNavProps) {
  const tabs = [
    { id: 'overview', label: 'Home', icon: LayoutGrid },
    { id: 'expenditure', label: 'Spend', icon: List },
    { id: 'income', label: 'Income', icon: DollarSign },
    { id: 'support', label: 'Support', icon: Gift },
  ] as const;

  if (activeTab === 'asset-detail') return null;

  return (
    <nav className="safe-area-inset-bottom fixed right-0 bottom-0 left-0 z-50 grid grid-cols-4 border-t border-zinc-200 bg-zinc-100/80 px-2 py-3 backdrop-blur-xl transition-colors dark:border-white/5 dark:bg-zinc-900/80">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className="relative flex flex-col items-center justify-center gap-1 py-1"
        >
          <tab.icon
            className={cn(
              'h-6 w-6 transition-all duration-300',
              activeTab === tab.id
                ? 'scale-110 text-indigo-600 dark:text-indigo-400'
                : 'text-zinc-400 hover:text-zinc-900 dark:text-zinc-500 dark:hover:text-zinc-100'
            )}
          />
          <span
            className={cn(
              'text-[9px] font-bold tracking-widest uppercase transition-all duration-300',
              activeTab === tab.id
                ? 'text-zinc-900 dark:text-white'
                : 'text-zinc-400 dark:text-zinc-500'
            )}
          >
            {tab.label}
          </span>
          {activeTab === tab.id && (
            <motion.div
              layoutId="nav-indicator"
              className="absolute -bottom-1 h-1 w-1 rounded-full bg-indigo-600 dark:bg-indigo-400"
            />
          )}
        </button>
      ))}
    </nav>
  );
}
